// Bảng ánh xạ đường dẫn theo ngôn ngữ
export const langRoutes = {
  home: {
    vi: '/vi',
    en: '/en',
    lv: '/lv',
  },
  exportServices: {
    vi: '/vi/dich-vu-xuat-khau',
    en: '/en/export-services',
    lv: '/lv/eksporta-pakalpojumi',
  },
  choHem: {
    vi: '/vi/cho-hem',
    en: '/en/cho-hem',
    lv: '/lv/cho-hem',
  },
  latvia: {
    vi: '/vi/dinh-cu-latvia',
    en: '/en/immigration-latvia',
    lv: '/lv/latvija',
  },
  latviaDetail: {
    vi: '/vi/dinh-cu-latvia/chi-tiet',
    en: '/en/immigration-latvia/detail',
    lv: '/lv/latvija/detalizeti',
  },
  latviaPartnership: {
    vi: '/vi/dinh-cu-latvia/hop-tac',
    en: '/en/immigration-latvia/partnership',
    lv: '/lv/latvija/partneriba',
  },
  latviaBlog: {
    vi: '/vi/dinh-cu-latvia/blog',
    en: '/en/immigration-latvia/blog',
    lv: '/lv/latvija/blogs',
  },
  about: {
    vi: '/vi/ve-chung-toi',
    en: '/en/about-us',
    lv: '/lv/par-mums',
  },
  contact: {
    vi: '/vi/lien-he',
    en: '/en/contact',
    lv: '/lv/kontakti',
  },
} as const;

export type RouteKey = keyof typeof langRoutes;
export type Language = 'vi' | 'en' | 'lv';

// Helper function để lấy path theo ngôn ngữ
export function getLangPath(routeKey: RouteKey, lang: Language): string {
  return langRoutes[routeKey][lang];
}

// Helper function để lấy path cho blog detail
export function getBlogDetailPath(slug: string, lang: Language): string {
  const basePath = langRoutes.latviaBlog[lang];
  return `${basePath}/${slug}`;
}

// Reverse mapping: từ pathname → routeKey
export function getRouteKeyFromPath(pathname: string): RouteKey | null {
  // Loại bỏ trailing slash
  const cleanPath = pathname.replace(/\/$/, '');
  
  // Tìm routeKey tương ứng
  for (const [key, paths] of Object.entries(langRoutes)) {
    const routeKey = key as RouteKey;
    if (
      paths.vi === cleanPath ||
      paths.en === cleanPath ||
      paths.lv === cleanPath
    ) {
      return routeKey;
    }
  }
  
  // Kiểm tra blog detail pattern
  if (
    cleanPath.startsWith('/vi/dinh-cu-latvia/blog/') ||
    cleanPath.startsWith('/en/immigration-latvia/blog/') ||
    cleanPath.startsWith('/lv/latvija/blogs/')
  ) {
    return 'latviaBlog';
  }
  
  // Kiểm tra export services
  if (
    cleanPath === '/vi/dich-vu-xuat-khau' ||
    cleanPath === '/en/export-services' ||
    cleanPath === '/lv/eksporta-pakalpojumi'
  ) {
    return 'exportServices';
  }
  
  return null;
}

// Helper function để lấy ngôn ngữ từ pathname
export function getLangFromPath(pathname: string): Language | null {
  if (pathname.startsWith('/vi')) return 'vi';
  if (pathname.startsWith('/en')) return 'en';
  if (pathname.startsWith('/lv')) return 'lv';
  return null;
}